// InviteRow.js
import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { deleteDoc, doc, getDoc } from 'firebase/firestore';
import { httpsCallable } from 'firebase/functions';
import { db, functions } from '../../firebase-client';
import { useAuth } from '../../auth/AuthContext';
import { syncMemberCalendarToFamily } from '../../utils/syncFamilyCalendar';
export default function InviteRow({
  invite,
  onAction
}) {
  const {
    user
  } = useAuth();
  const acceptFamilyInviteFn = httpsCallable(functions, 'acceptFamilyInvite');
  const declineFamilyInviteFn = httpsCallable(functions, 'declineFamilyInvite');
  const [teamName, setTeamName] = useState('');
  const [memberName, setMemberName] = useState('');

  // Load team/member names for team join requests
  useEffect(() => {
    if (invite.inviteType === 'Team Join Request' && invite.team) {
      getDoc(doc(db, 'teams', invite.team)).then(teamDoc => {
        setTeamName(teamDoc.exists() ? teamDoc.data().name || '(Unnamed Team)' : '(Unknown Team)');
      }).catch(() => {});
      if (invite.senderId) {
        getDoc(doc(db, 'users', invite.senderId)).then(userDoc => {
          if (userDoc.exists()) {
            const data = userDoc.data();
            const name = [data.firstName, data.lastName].filter(Boolean).join(' ');
            setMemberName(name || 'a member');
          }
        }).catch(() => {});
      }
    }
  }, [invite]);
  const handleAcceptFamily = async () => {
    try {
      const famId = invite.familyId;
      await acceptFamilyInviteFn({
        familyId: famId,
        inviteId: invite.id,
      });
      try {
        await syncMemberCalendarToFamily(db, user.uid, famId);
      } catch (err) {}
      await onAction();
    } catch (err) {
      alert(`Could not process invite: ${err.message}`);
    }
  };
  const handleDecline = async () => {
    try {
      if (invite.inviteType === 'Included Membership') {
        await httpsCallable(functions, 'manageAdditionalAccounts')({ action: 'decline', teamId: invite.team, key: invite.additionalAccountKey });
      } else if (invite.inviteType === 'Family') {
        await declineFamilyInviteFn({
          familyId: invite.familyId,
          inviteId: invite.id,
        });
      } else {
        await deleteDoc(doc(db, 'invitations', user.uid, 'invites', invite.id));
      }
      await onAction();
    } catch (err) {
      alert(`Could not decline invite: ${err.message}`);
    }
  };

  // Label text
  let label = '';
  if (invite.inviteType === 'Family') {
    const familyLabel = invite.familyName || 'family';
    label = `Family invite to “${familyLabel}” as ${invite.role}`;
  } else if (invite.inviteType === 'Included Membership') {
    label = `Included membership invitation to ${invite.teamName || 'your club'}`;
  } else if (invite.inviteType === 'Team Join Request') {
    label = memberName ? `Join request from ${memberName} to join “${teamName}”` : `Request to join team “${teamName}”`;
  } else {
    label = `Invite: ${invite.inviteType}`;
  }
  return <div className="invite-row">
      <span className="invite-text">{label}</span>
      <div className="invite-actions">
        {invite.inviteType === 'Included Membership' ? <Link to={`/join/${invite.team}?included=${invite.additionalAccountKey}`} className="button">Review invitation</Link> : invite.inviteType === 'Team Join Request' ? <Link to={`/join/${invite.team}`} className="button">
            Join
          </Link> : <button onClick={handleAcceptFamily} className="button">
            Approve
          </button>}
        <button onClick={handleDecline} className="button button-secondary">
          Reject
        </button>
      </div>
    </div>;
}
